"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Option(_a) {
    var name = _a.name, className = _a.className, value = _a.value, onChange = _a.onChange;
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-channels-form-layout-options', className) },
        react_1.default.createElement(storybook_1.Forms.Label, { type: 'lg' }, name),
        react_1.default.createElement(storybook_1.Forms.Toggle, { value: value, onClick: function () { return onChange(!value); } }));
}
exports.default = Option;
